"use client";

import React, { useEffect, useState } from "react";
import fashionApi from "@/Apis/FashionApi";
import FashionProductCard from "../../../common/FashionProductCard";
import SliderWrapper from "../../../common/SlidderWrapper";

const STORAGE_KEY = "recentlyViewedProducts";
const MAX_ITEMS = 6;

function getRecentlyViewed() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

function addToRecentlyViewed(handle) {
  const handles = getRecentlyViewed().filter((h) => h !== handle);
  handles.push(handle);
  if (handles.length > MAX_ITEMS) {
    handles.shift();
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
  return handles;
}

const RecentlyViewedProducts = ({ handle, currency, storeId }) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const handles = addToRecentlyViewed(handle);
    const otherHandles = handles.filter((h) => h !== handle);

    if (otherHandles.length === 0) return;

    const fetchProducts = async () => {
      const results = await Promise.all(
        otherHandles.map((h) =>
          fashionApi
            .getProductDetails(h, { storefront: storeId })
            .then((res) => {
              const product = res.data;
              return {
                id: product.id,
                title: product.title,
                handle: product.handle,
                images: product.images.map((img) =>
                  typeof img === "string" ? img : img.cdn_link
                ),
                sold_out: product.variants?.[0]?.variant_detail?.sold_out,
                variant_detail: product.variants?.[0]?.variant_detail,
              };
            })
            .catch(() => null)
        )
      );
      setProducts(results.filter(Boolean));
    };

    fetchProducts();
  }, [handle, storeId]);

  if (products.length === 0) return null;

  return (
    <div className="related-products">
      <h3 className="related-products-title">Recently Viewed Products</h3>
      <SliderWrapper itemWidth={350}>
        {products.map((product) => (
          <FashionProductCard
            product={product}
            key={product.id}
            currency={currency}
          />
        ))}
      </SliderWrapper>
    </div>
  );
};

export default RecentlyViewedProducts;
